'use strict';

import Link from 'next/link';
import PropTypes from 'prop-types';
import React from 'react';
import { trackCustomEvent } from '../../../../utils/statistics/clientStatistics';
import { mainMenuItemClickEvent } from '../../../../utils/statistics/customEvents';
import { Link as StyledMenuLink, ListItem } from './MenuItem.styles';

export const MenuItem = ({ route, accessKey, type, text, index, currentPath }) => {
    return (
        <ListItem type={type} data-rt="menu-item">
            <Link href={route} passHref>
                <StyledMenuLink
                    isActive={route === currentPath}
                    className={route === currentPath ? 'play_is-active' : null} // For integration tests
                    accessKey={accessKey}
                    onClick={() => {
                        trackCustomEvent(mainMenuItemClickEvent(text, index));
                    }}
                >
                    {text}
                </StyledMenuLink>
            </Link>
        </ListItem>
    );
};

MenuItem.propTypes = {
    route: PropTypes.string.isRequired,
    accessKey: PropTypes.string.isRequired,
    type: PropTypes.string,
    text: PropTypes.string.isRequired,
    isIndexLink: PropTypes.bool,
    index: PropTypes.number,
};

export default MenuItem;
